<template>
  <div class="zuzhijigou">
    <!-- 面包屑导航 -->
    <div class="mianbao">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <!-- <el-breadcrumb-item :to="{ path: '/partyBuildingIndex' }">首页</el-breadcrumb-item> -->
        <el-breadcrumb-item :to="{ path: '/communityServices1' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>智慧协商</el-breadcrumb-item>
        <el-breadcrumb-item>新增组织</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="card-box">
      <!-- 左边卡片 -->
      <!-- <el-card
          :body-style="{ padding: '16px',width: 'calc(100% - 32px)' }"
          class="card-l zzjg_con"
      >
        <el-tree :data="data" :props="defaultProps" accordion @node-click="handleNodeClick" default-expand-all>
                    <span ref="tree" class="span-ellipsis" slot-scope="{ node, data }">
                        <span :title="node.label">{{ node.label }}</span>
                    </span>
        </el-tree>
      </el-card> -->

      <!-- 右边卡片 -->
      <div class="card-rb">
        <div class="card-4">
          <el-card :body-style="{ padding: '16px' }">
            <div
              id="chartss"
              style="height:300px;width:100%;display:none;"
            ></div>
            <div class="fisthang">
              <el-form
                :inline="true"
                :model="searchlist"
                class="demo-form-inline"
                size="mini"
              >
                <el-form-item
                  label="组织名称:"
                  style="margin:0 30px 0 0;"
                >
                  <el-input
                    v-model="searchlist.name"
                    placeholder="请输入组织名称"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="状态:"
                  style="margin:0 30px 0 0;"
                >
                  <el-radio-group v-model="searchlist.status">
                    <el-radio label="0">启用</el-radio>
                    <el-radio label="1">禁用</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="success"
                    size="mini"
                    @click="showDialog(0, 'insert')"
                  >新增
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="queryClick"
                  >查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="info"
                    @click="searchlistReset"
                  >重置</el-button>
                </el-form-item>
              </el-form>
            </div>
            <!-- 表格盒子 -->
            <div class="table_card">
              <el-table
                :data="tableDatazhu"
                v-loading="tableLoading"
                :header-cell-style="{ background: '#f8fafa' }"
                border
                align="center"
                current-row-key
                highlight-current-row
              >
                <!-- <el-table-column type="selection" align="center"></el-table-column> -->
                <el-table-column
                  type="index"
                  align="center"
                  label="序号"
                  width="70"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="name"
                  label="组织名称"
                  width="250"
                  :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="address"
                  label="地址"
                  width="180"
                  :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="type"
                  label="组织类型"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.type == 0">可由村级协商委员会负责协商</span>
                    <span v-if="scope.row.type == 1">村干部为组长的下属协商委员会负责协商</span>
                    <span v-if="scope.row.type == 2">村协商委员会主任牵头组织协商</span>
                    <span v-if="scope.row.type == 3">镇党委、政府指定镇负责同志牵头组织协商</span>
                    <span v-if="scope.row.type == 4">第三方组织</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="introduce"
                  label="组织介绍"
                  :show-overflow-tooltip="true"
                ></el-table-column>
                <!-- <el-table-column prop="photo" label="组织主图" align="center" width="150">
                  <template slot-scope="scope">
                    <img :src="scope.row.photo" alt style="width:80px;height:40px" />
                  </template>
                </el-table-column> -->
                <el-table-column
                  align="center"
                  prop="status"
                  width="100"
                  label="状态"
                >
                  <template slot-scope="scope">
                    <el-switch
                      v-model="scope.row.status"
                      active-value="0"
                      inactive-value="1"
                      @change="changeStatus(scope.row)"
                    ></el-switch>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  label="操作"
                  width="200"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <!-- 包裹按钮的悬浮提示 -->
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="修改"
                      placement="top-start"
                    >
                      <button
                        class="iconfont icon-bianji3 tabBtn"
                        @click="showDialog(scope.row.id, 'update')"
                      ></button>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="删除"
                      placement="top-start"
                    >
                      <button
                        class="iconfont icon-icon7 tabBtn"
                        style="color:#e65a50"
                        @click="deleteClick(scope.row.id)"
                      ></button>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="查看"
                      placement="top-start"
                    >
                      <button
                        class="iconfont icon-chakan tabBtn"
                        style="color:#329cd0"
                        @click="showDialog(scope.row.id, 'look')"
                      ></button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页功能 -->
              <!--background背景色 :page-sizes="[10,20]"页码选择器   layout显示什么内容  total总条数 -->
              <el-pagination
                :page-size="pageConfig.pageSize"
                layout="total, prev, pager, next, jumper"
                @current-change="handleCurrentChange"
                :total="pageConfig.total"
              ></el-pagination>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 弹出框修改 -->
    <el-dialog
      title="修改"
      :visible.sync="showmodify"
      width="1100px"
      :before-close="clearmodifyData"
    >
      <el-form
        ref="modifyfrom"
        :rules="rules"
        :model="modifyfrom"
        label-width="120px"
        size="mini"
      >
        <el-form-item
          v-if="modifyfrom.parentId !== 0"
          label="上级组织:"
          style="margin:0 30px 0 0; height:50px"
        >
          <!-- <el-input v-model="labelName"  style="width:400px"></el-input> -->

          <el-select
            class="marginT34"
            v-model="modifyfrom.parentName"
            placeholder="请选择上级组织"
            ref="selectBoxRef"
          >
            <el-option
              :value="modifyfrom.parentId"
              style="height: auto;"
            >
              <el-tree
                :data="data"
                :props="defaultProps"
                @node-click="handleEditNodeClick"
                class="tree_box"
              ></el-tree>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="组织名称:"
          prop="name"
          style="margin:0 30px 0 0; height:50px"
        >
          <el-input
            v-model="modifyfrom.name"
            placeholder="请输入组织名称"
            style="width:400px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="所在地:"
          prop="linkAddr"
          style="margin:0 30px 0 0; height:50px"
        >
          <el-input
            v-model="modifyfrom.linkAddr"
            @click.native="showMapView('edit')"
            readonly="readonly"
            placeholder="请选择位置"
            style="width:400px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="负责人:"
          prop="linkMain"
          style="margin:0 30px 0 0; height:50px"
        >
          <el-input
            v-model="modifyfrom.linkMain"
            placeholder="请输入负责人姓名"
            style="width:400px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="联系电话:"
          prop="linkPhone"
          style="margin:0 30px 0 0; height:50px"
        >
          <el-input
            v-model="modifyfrom.linkPhone"
            placeholder="请输入联系电话"
            style="width:400px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="备注:"
          prop="remarks"
          style="margin:0 30px 0 0; height:50px"
        >
          <el-input
            v-model="modifyfrom.remarks"
            placeholder="请输入备注"
            style="width:400px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="状态:"
          style="margin:0 30px 0 0; height:50px"
        >
          <el-radio-group v-model="modifyfrom.status">
            <el-radio label="0">启用</el-radio>
            <el-radio label="1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="boontbtn">
        <el-button
          type="primary"
          size="small"
          style="margin: 0 30px"
          @click="modify"
        >保存</el-button>
        <el-button
          type="info"
          size="small"
          @click="clearmodifyData"
        >取消</el-button>
      </div>
    </el-dialog>
    <!-- 组织弹窗 -->
    <Party
      v-if="showParty"
      :streetTree="streetTree"
      :show="showParty"
      :id="addfromId"
      :typeString="addfromType"
      :partyTree="data"
      :addMemberData="addMemberData"
      :addMemberDatas="addMemberDatas"
      :parentData="parentData"
      @close="closeParty"
    />
    <!-- 弹出框查看 -->
    <el-dialog
      title="查看"
      :visible.sync="showcheck"
      width="1100px"
    >
      <el-form
        ref="seefrom"
        :model="seefrom"
        label-width="120px"
        size="mini"
        disabled
      >
        <el-form-item
          label="上级组织:"
          style="margin:0 30px 0 0; height:50px"
        >
          <el-input
            v-model="seefrom.parentName"
            disabled
            style="width:400px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="组织名称:"
          style="margin:0 30px 0 0; height:50px"
        >
          <el-input
            v-model="seefrom.name"
            placeholder="请输入组织名称"
            style="width:400px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="负责人:"
          prop="linkMain"
          style="margin:0 30px 0 0; height:50px"
        >
          <el-input
            v-model="seefrom.linkMain"
            placeholder="请输入负责人姓名"
            style="width:400px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="联系电话:"
          prop="linkPhone"
          style="margin:0 30px 0 0; height:50px"
        >
          <el-input
            v-model="seefrom.linkPhone"
            placeholder="请输入联系电话"
            style="width:400px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="备注:"
          prop="remarks"
          style="margin:0 30px 0 0; height:70px"
        >
          <el-input
            v-model="seefrom.remarks"
            placeholder="请输入备注"
            style="width:400px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="状态:"
          style="margin:0 30px 0 0; height:50px"
        >
          <el-radio-group v-model="seefrom.status">
            <el-radio label="0">启用</el-radio>
            <el-radio label="1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="boontbtn">
        <el-button
          type="info"
          size="medium"
          @click="showcheck=false"
        >取消</el-button>
      </div>
    </el-dialog>

    <!-- 地图选择 -->
    <el-dialog
      title="选择坐标"
      :visible.sync="showMap"
      width="300px; height:200px"
    >
      <div
        class="maponebuttom"
        id="mapContainer"
      ></div>
      <!-- <mapAddr ref="mapAddr" /> -->
      <div class="boontbtn">
        <el-button
          type="info"
          size="medium"
          @click="showMap=false"
        >关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  findPartyOrgBuild,
  insertPartyOrgBuild,
  findPartyOrgBuildById,
  updatePartyOrgBuild,
  deletePartyOrgBuild,
  findPartyOrgBuildTreelist,
} from "@/api/http"
import { post } from "@/api/requrestHttp"
import Party from "@/views/platform/gridding/zuzhixinzeng/Insert"
import request from "@/utils/request.js"
import AMap from "AMap" // 引入高德地图
import G6 from "@antv/g6"
// import mapAddr from './map/mapAddr'
var map, marker
export default {
  components: { Party },
  computed: {
    orgLevel() {
      return this.$store.state.info.orgLevel
    },
  },
  data() {
    return {
      value: true,
      value1: false,
      // 树形控件的配置
      defaultProps: {
        children: "children",
        label: "label",
      },
      //  树形控件
      data: [],
      //  会出现的所属组织列表
      parentParty: [],
      modifyfrom: {
        name: "",
        status: "",
        parentId: "1",
        parentName: "",
        linkAddr: "",
      },
      // 添加
      addfrom: {
        name: "",
        status: "0",
        parentId: 0,
        linkAddr: "",
        shujijianjie: "",
      },
      // 书记副书记数据
      addMemberData: [],
      // 成员数据
      addMemberDatas: [],
      fushuji: [],
      seefrom: {
        name: "",
        status: "",
      },
      mapfrom: {},
      searchlist: {
        name: "",
        status: "",
      },
      // 父节点名称
      labelName: "",
      parentData: {
        id: 0,
        labelName: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入组织名称",
            trigger: "blur",
          },
        ],
      },
      //表格数据
      tableDatazhu: [],
      tableLoading: false,
      // 分页配置
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1,
      },
      //修改弹出层
      showmodify: false,

      shouthreetypedata: "",

      // 新增弹出层
      showadd: false,
      showParty: false,
      addfromType: "",
      addfromId: 0,
      //查看弹出层
      showcheck: false,
      //弹出框编辑
      showredact: false,
      // 地图选择层
      showMap: false,
      arriveCoor: [], //坐标点
      arrive: "", //位置信息
      // 地图相关选择
      mapOptions: {
        labeltext: "活动地址:",
        mapid: "addMap",
        city: "cityName",
        area: "areaName",
        street: "streetName",
        fatherdata: {
          cityName: "",
          areaName: "",
          streetName: "",
          address: "",
        },
      },
      streetTree: [], // 街道列表， 地图需要使用
      eacherType: true,
    }
  },
  methods: {
    handleAuth(item) {
      let bool
      switch (this.orgLevel) {
        case 2:
          bool = true
          break
        case 3:
          item.orgLevel == "3" || item.orgLevel == "4"
            ? (bool = true)
            : (bool = false)
          break
        case 4:
          item.orgLevel == "4" ? (bool = true) : (bool = false)
          break
        default:
          bool = false
      }
      return bool
    },
    //获取成员名称的方法
    getMemberNmae(arr, type) {
      // console.log(1111)
      // let getMembedata = {
      //       pageNo:1,
      //       pageSize:100,
      //       partyGroupCode:this.parentData.id
      // }
      let request = {
        pageNo: 1,
        pageSize: 999,
        userPosts: arr,
      }
      post("/admin/user/info/list", request).then((res) => {
        // console.log(res)
        if (type == 1) {
          this.addMemberData = res.content.list
        } else {
          this.addMemberDatas = res.content.list
        }
      })
    },
    // 树形控件点击事件
    // handleNodeClick(data) {
    //   this.parentData = {
    //     labelName: data.label,
    //     id: data.orgId,
    //   };
    //   this.pageConfig.pageNo = 1;
    //   this.tablelist();
    //   this.getMemberNmae([4, 6, 2, 12], 1);
    //   this.getMemberNmae([4, 3, 5, 6, 8, 7, 9, 10, 11, 2, 14, 12, 1], 2);
    // },
    async findTreelist(fn) {
      let res = await findPartyOrgBuildTreelist({})
      console.log("res", res)
      this.data = res.content
      this.parentData = {
        labelName: res.content[0].label,
        id: res.content[0].orgId,
      }
      fn && fn()
      const arr = []
      this.getChildArr(res.content, arr)
      this.parentParty = arr
      if (this.eacherType) {
        this.eacherTop()
      }
    },
    getChildArr(arg, arr) {
      arg.forEach((item) => {
        let newItem = {
          label: item.label,
          orgId: item.orgId,
        }
        arr.push(newItem)
        if (item.children && item.children.length > 0) {
          this.getChildArr(item.children, arr)
        }
      })
    },
    // 重置
    searchlistReset() {
      this.searchlist = {
        name: "",
        status: "",
      }
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.tablelist()
    },
    clearmodifyData() {
      this.modifyfrom = {}
      this.showmodify = false
    },
    //清空增加的信息
    clearadddata() {
      this.addfrom = {}
      this.showadd = false
    },
    queryClick() {
      this.tablelist()
    },
    // 获取列表数据
    async tablelist() {
      this.tableLoading = true

      try {
        let res = await findPartyOrgBuild({
          name: this.searchlist.name,
          status: this.searchlist.status,
          pageNo: this.pageConfig.pageNo,
          pageSize: 10,
          // orgId: this.parentData.id,
        })
        if (res.code == 200) {
          console.log(res)
          this.pageConfig.total = res.content.count
          this.tableDatazhu = res.content.list
        }
      } finally {
        this.tableLoading = false
      }
    },
    // 新增表格数据
    async addTable(fromAdd) {
      if (this.addfrom.parentId == 0) {
        this.addfrom.level = 0
      }
      this.$refs[fromAdd].validate((valid) => {
        if (valid) {
          insertPartyOrgBuild(this.addfrom)
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success",
                })
                this.tablelist()
                this.findTreelist()
                this.addfrom = []
              } else {
                this.$message({
                  message: "新增失败",
                  type: "error",
                })
              }
              this.showadd = false
            })
            .catch((err) => {
              this.showadd = false
            })
        }
      })
    },
    // 获取修改弹出框数据
    async modifyClick(id) {
      let res = await findPartyOrgBuildById(id)
      this.modifyfrom = res.content
      if (this.modifyfrom.parentId > 0) {
        let resParent = await findPartyOrgBuildById(this.modifyfrom.parentId)
        this.modifyfrom.parentName = resParent.content.name
      }
      this.showmodify = true
    },
    // 修改表格数据
    async modify() {
      let name = this.modifyfrom.name

      if (name == "" || typeof name === "undefined") {
        this.$message({
          message: "请输入组织名称",
          type: "warning",
        })
        return
      }

      post("/admin/consulOrg/info/updateConsultOrg", this.modifyfrom)
        .then((res) => {
          console.log(res)
          if (res.code == 200) {
            this.$message({
              message: "修改成功",
              type: "success",
            })
            this.tablelist()
            this.findTreelist()
          } else {
            this.$message({
              message: "修改失败",
              type: "error",
            })
          }
        })
        .catch(function (error) {
          console.log(error)
        })

      this.showmodify = false
    },
    // 获取查看弹出框数据
    async seeClick(id) {
      let res = await findPartyOrgBuildById(id)
      this.seefrom = res.content
      if (this.seefrom.parentId > 0) {
        let resParent = await findPartyOrgBuildById(this.seefrom.parentId)
        this.seefrom.parentName = resParent.content.name
      }
      this.showcheck = true
    },
    // 表格删除
    deleteClick(id) {
      this.$confirm("此操作将删除该组织信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })

        .then(async () => {
          let res = await deletePartyOrgBuild(id)
          console.log(res)
          if (res.code == 201) {
            this.$message({
              message: res.message,
              type: "warning",
            })
          }
          if (res.code == 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            })
            this.tablelist()
            this.findTreelist()
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          })
        })
    },
    //改变状态
    async changeStatus(cdata) {
      this.modifyfrom = {}
      this.modifyfrom = cdata
      post("/admin/consulOrg/info/updateConsultOrg", this.modifyfrom)
        .then((res) => {
          console.log(res)
          if (res.code == 1) {
            var msg = "状态"
            msg = msg + (cdata.status == "1" ? "禁用" : "启用")
            if (res.code == 200) {
              this.$message({
                message: msg + "成功",
                type: "success",
              })
              this.findTreelist()
            } else {
              this.$message({
                message: msg + "失败：" + res.message,
                type: "error",
              })
            }
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    handleEditNodeClick(info, e) {
      this.modifyfrom.parentName = info.label
      this.modifyfrom.parentId = info.orgId
      console.log(this.modifyfrom.parentId)
      this.$refs["selectBoxRef"].handleClose()
    },
    initMap(types) {
      map = new AMap.Map("mapContainer", {
        center: [117.474991, 30.653994],
        resizeEnable: true, // 是否监控地图容器尺寸变化
        zoom: 14,
      })
      if (types == "add") {
        this.addMarker(this.addfrom.linkAddr)
      } else {
        this.addMarker(this.modifyfrom.linkAddr)
      }

      //定义地图坐标点击事件
      var that = this
      map.on("click", function (e) {
        if (types == "add") {
          that.addfrom.linkAddr = e.lnglat.getLng() + "," + e.lnglat.getLat()
        } else {
          that.modifyfrom.linkAddr = e.lnglat.getLng() + "," + e.lnglat.getLat()
        }

        marker = new AMap.Marker({
          position: [e.lnglat.getLng(), e.lnglat.getLat()],
          draggable: false,
          cursor: "move",
          // 设置拖拽效果
          raiseOnDrag: false,
        })
        marker.setMap(map)
        that.showMap = false
      })
    },
    addMarker(arrive) {
      if (arrive == "" || arrive == null) {
        return
      }
      var pos = arrive.split(",")
      var that = this
      marker = new AMap.Marker({
        position: pos,
        draggable: false,
        cursor: "move",
        // 设置拖拽效果
        raiseOnDrag: false,
      })
      marker.setMap(map)
    },
    showMapView(types) {
      this.initMap(types)
      this.showMap = true
    },
    // 图表加载函数
    async drawChart() {
      let data = [
        {
          id: "秋浦街道党工委",
          children: [
            { name: "AgglomerativeCluster", value: 3938 },
            { name: "CommunityStructure", value: 3812 },
            { name: "HierarchicalCluster", value: 6714 },
            { name: "MergeEdge", value: 743 },
          ],
        },
        {
          name: "湖心社区党委",
          children: [
            { name: "BetweennessCentrality", value: 3534 },
            { name: "LinkDistance", value: 5731 },
            { name: "MaxFlowMinCut", value: 7840 },
            { name: "ShortestPaths", value: 5914 },
            { name: "SpanningTree", value: 3416 },
          ],
        },
        {
          name: "孝肃社区党委",
          children: [{ name: "AspectRatioBanker", value: 7074 }],
        },
      ]
      //   };
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("chartss"))
      // 指定图表的配置项和数据
      myChart.setOption({
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
        },
        textStyle: {
          color: "#fff",
        },
        series: [
          {
            type: "tree",
            data: [data],
            left: "2%",
            right: "2%",
            top: "8%",
            bottom: "20%",
            orient: "TB",
            symbol: "circle",
            symbolSize: 1,
            edgeShape: "polyline",
            expandAndCollapse: true,
            label: {
              position: "top",
              rotate: 0,
              verticalAlign: "middle",
              align: "center",
              fontSize: 13,
              borderColor: "#666",
              borderWidth: 2,
              borderRadius: 2,
              padding: [6, 6, 6, 6],
            },
            defaultNode: {
              type: "rect",
              size: [110, 30],
              anchorPoints: [
                [0, 0.5],
                [1, 0.5],
              ],
              style: {
                radius: 10,
                fill: "#C6E5FF",
                stroke: "#5B8FF9",
              },
            },
            defaultEdge: {
              type: "polyline",
              sourceAnchor: 0.5, // 锚点索引
              targetAnchor: 1, // 锚点索引
              style: {
                radius: 10,
                endArrow: false,
                lineWidth: 1,
                stroke: "#C2C8D5",
              },
              labelCfg: {
                position: "end",
                style: {
                  fill: "#595959",
                },
              },
            },
            itemStyle: {},
            animationDurationUpdate: 750,
          },
        ],
      })
    },
    // Editor文字修改
    editorUpdate(val, item) {
      console.log(val, item)
      item.desc = val
    },
    // 地图方法
    setmapOption(data) {
      //   console.log("setmapOption====", data);

      this.mapOptions.mapid = "setmap1"

      this.mapOptions.fatherdata.activityAddressDetail =
        data.activityAddressDetail

      this.mapOptions.fatherdata.addressDetail = data.activityAddressDetail

      this.mapOptions.fatherdata.areaName = data.areaName
      this.mapOptions.fatherdata.latitude = data.activityAddress.split(",")[0]
      this.mapOptions.fatherdata.longitude = data.activityAddress.split(",")[1]
      this.mapOptions.fatherdata.cityName = data.cityName
      this.mapOptions.fatherdata.streetName = data.streetName
    },
    addressMapBack(data, key) {
      console.log(data)
      this[key] = Object.assign(this[key], data)
    },
    // 获取街道树形列表
    async getTreeDatas() {
      const res = await request({
        url: "/rbac/admin/org/info/OrgTreelist",
        method: "POST",
        data: { orgType: "1",isValid: 1, },
      })
      this.streetTree = res.content
    },
    // 上传照片相关
    shujiAvatar(res, file, item) {
      item.avatar = res.content.path
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg"
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!")
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!")
      }
      return isJPG && isLt2M
    },
    // 副书记数据格式
    getFushuji() {
      return {
        avatar: "",
        name: "",
        desc: "",
      }
    },
    addFushuji() {
      if (!this.fushuji[this.fushuji.length - 1].name) {
        this.$message({
          message: "请至少填写前一个副书记姓名",
          type: "warning",
        })
        return
      }
      this.fushuji.push(this.getFushuji())
    },
    // 显示新增
    showDialog(id, type) {
      this.showParty = true
      this.addfromType = type
      this.addfromId = id
      // this.member.photo = []
      // console.log(this.member.photo);
      this.getMemberNmae([4, 6, 2, 12], 1)
      this.getMemberNmae([4, 3, 5, 6, 8, 7, 9, 10, 11, 2, 14, 12, 1], 2)
    },
    closeParty(bool) {
      this.addfromId = 0
      this.showParty = false
      if (bool) {
        this.findTreelist()
        this.tablelist()
      }
    },
    returnChildren(data) {
      if (data.children) {
        return data.children
      } else {
      }
    },
    eacherTop() {
      let data = JSON.parse(JSON.stringify(this.data[0]))

      function addId(obj) {
        let func = arguments
        obj.id = obj.label
        if (obj.children && obj.children.length) {
          obj.children.map((item) => {
            addId(item)
          })
        }
      }

      addId(data)
      const width = document.getElementById("chartss").scrollWidth
      const height = document.getElementById("chartss").scrollHeight || 500
      const graph = new G6.TreeGraph({
        container: "chartss",
        width,
        height,
        pixelRatio: 2,
        linkCenter: true,
        modes: {
          default: [
            {
              type: "collapse-expand",
              onChange: function onChange(item, collapsed) {
                const data = item.get("model").data
                data.collapsed = collapsed
                return true
              },
            },
          ],
        },
        defaultNode: {
          shape: "rect",
          size: [110, 30],
          anchorPoints: [
            [0, 0.5],
            [1, 0.5],
          ],
          style: {
            radius: 10,
            fill: "#C6E5FF",
            stroke: "#5B8FF9",
          },
        },
        defaultEdge: {
          shape: "polyline",
          sourceAnchor: 0.5, // 锚点索引
          targetAnchor: 1, // 锚点索引
          style: {
            radius: 10,
            endArrow: false,
            lineWidth: 1,
            stroke: "#C2C8D5",
          },
          labelCfg: {
            position: "end",
            style: {
              fill: "#595959",
            },
          },
        },
        layout: {
          type: "compactBox",
          direction: "TB",
          getId: function getId(d) {
            return d.id
          },
          getHeight: function getHeight() {
            return 16
          },
          getWidth: function getWidth() {
            return 52
          },
          getVGap: function getVGap() {
            return 22
          },
          getHGap: function getHGap() {
            return 40
          },
        },
      })
      graph.node(function (node) {
        return {
          label: node.id,
        }
      })
      graph.data(data)
      graph.render()
      graph.fitView()
      this.eacherType = false
    },
  },
  mounted() {
    this.getTreeDatas()
    this.findTreelist(this.tablelist)
  },
}
</script>

<style lang="less" scoped>
.zuzhijigou {
  background-color: #eef1f6;
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
  min-width: 1381px;
}

// 面包屑导航box
.mianbao {
  box-sizing: border-box;
  margin: -16px -16px 0;
  background-color: #fff;
  height: 47px;
  display: flex;
  align-items: center;
  padding-left: 16px;
  margin-bottom: 16px;
}

//  包裹两个卡片的盒子
.card-box {
  display: flex;
  // 左边树状列表卡片
  .card-l {
    width: 270px;
  }

  .card-r {
    // overflow: hidden;
    flex: 1;
    margin-left: 16px;
    height: 320px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .card-0 {
      width: 32.5%;
      height: 320px;
    }

    .card-2 {
      width: 32.5%;
      height: 320px;

      .onebuttom {
        height: 258px;
        // background-color: red;
        div {
          width: 100%;
          height: 100%;
        }
      }
    }

    .card-3 {
      width: 32.5%;
      height: 320px;
    }

    .topbarnav {
      display: flex;
      align-items: center;

      div {
        box-sizing: border-box;
        padding: 0 10px;
        font-size: 14px;
      }
    }
  }
}

.card-4 {
  width: 100%;
  // height: 320px;
  box-sizing: border-box;
}

// 表格的盒子
.table_card {
  // overflow: hidden;
  // 解决表格无法自适应宽度
  // width: calc(100vw - 500px);
  margin: 16px 0 0 0;

  .el-table {
    width: 100%;
    // 表格里的按钮
    .tabBtn {
      margin: 0 6px;
    }

    .tabBtn:nth-child(1) {
      color: #199b5d;
    }

    .tabBtn:nth-child(2) {
      color: #a1a1a1;
    }

    .tabBtn:nth-child(3) {
      color: #dd3020;
    }

    .tabBtn:nth-child(4) {
      color: #2e99cf;
    }

    .active_Btn {
      color: #ff04ed !important;
    }
  }
}

.active_tab {
  color: #cd2b20 !important;
}

.active_tab1 {
  color: #0f7ef1 !important;
}

.active_tab2 {
  color: #1a9c5e !important;
}

.boontbtn {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
</style>
<style lang="less">
.main[data-v-336d350d] {
  min-width: 1578px !important;
}

.zuzhijigou {
  .el-form--inline .el-form-item {
    display: inline-block;
    margin-right: 10px !important;
    vertical-align: top;
  }

  .zuzhijigou .el-form--inline .el-form-item {
    display: inline-block;
    margin-right: 10px !important;
    vertical-align: top;
  }

  .el-dialog__header {
    height: 40px;
    padding: 1px;
    background-color: #01aaef;
  }

  .el-dialog__headerbtn {
    position: absolute;
    top: 8px;
    right: 20px;
    padding: 0;
    background: 0 0;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: 24px;
  }

  .el-dialog__title {
    display: block;
    margin-top: 9px;
    margin-left: 10px;
    color: #fff;
    font-size: 15px;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }

  .maponebuttom {
    width: 100%;
    height: 300px;
  }

  .detail {
    margin-right: 1px;
  }
}
</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.card-box .card-l {
  width: 270px;
  overflow: auto;
}

.el-tree-node__label {
  font-size: 14px;
  overflow-x: auto;
  overflow-y: hidden;
  text-overflow: inherit;
}

.el-card__body {
  padding: 20px;
  margin: 0;
  color: #333;
  position: relative;
}

.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  font-size: 14px;
}
</style>
